export default __webpack_public_path__ + "static/media/keymetrics.3567ade8.svg";